// Full searchable radio details from the supplied 2023 statewide channel plan.
export default String.raw`11.1|151.38500|110.9|159.27000|000.0|H|N|
11.2|153.95000|123.0|154.38500|000.0|H|N|
11.3|151.08500|136.5|156.19500|000.0|H|N|
11.4|151.44500|103.5|159.34500|000.0|H|N|
11.5|151.16000|192.8|151.16000|192.8|L|N|
11.6|151.17500|192.8|151.17500|192.8|L|N|
11.7|151.19000|192.8|151.19000|192.8|L|N|
11.8|151.32500|192.8|151.32500|192.8|L|N|
11.9|154.26500|156.7|154.26500|156.7|L|N|
11.10|154.29500|156.7|154.29500|156.7|L|N|
11.11|156.07500|156.7|156.07500|156.7|H|N|
11.12|159.36750|192.8|159.36750|192.8|L|N|
11.13|151.35500|103.5|159.30000|000.0|H|N|
11.14|151.26500|103.5|159.33000|000.0|H|N|
11.15|151.11500|123.0|155.43000|000.0|H|N|
11.16|151.22000|192.8|151.22000|192.8|L|N|
11.17|159.26250|192.8|159.26250|192.8|L|N|
11.18|153.77000|110.9|154.34000|OST|H|N|
11.19|153.89000|123.0|153.89000|123.0|L|N|
11.20|153.89000|156.7|154.37000|156.7|H|N|
11.21|154.01000|167.9|154.01000|167.9|L|N|
11.22|154.01000|210.7|154.44500|123.0|H|N|
11.23|154.07000|123.0|154.07000|123.0|L|N|
11.24|154.07000|156.7|159.00000|OST|H|N|
11.25|154.13000|167.9|154.13000|167.9|L|N|
11.26|154.13000|123.0|154.13000|123.0|L|N|
11.27|154.19000|167.9|154.19000|167.9|L|N|
11.28|154.19000|136.5|154.19000|136.5|L|N|
11.29|154.19000|123.0|154.19000|123.0|L|N|
11.30|154.20500|156.7|154.20500|156.7|L|N|
11.31|154.20500|167.9|154.20500|167.9|L|N|
11.32|154.20500|146.2|154.20500|146.2|L|N|
11.33|154.20500|123.0|154.20500|123.0|L|N|
11.34|154.35500|146.2|154.35500|146.2|L|N|
11.35|154.35500|167.9|153.83000|167.9|H|N|
11.36|154.44500|000.0|154.44500|000.0|L|N|
11.37|154.25000|167.9|154.25000|167.9|L|N|
11.38|154.25000|156.7|159.18000|156.7|H|N|
11.39|154.37000|123.0|154.37000|123.0|L|N|
11.40|154.32500|000.0|154.32500|000.0|L|N|
11.41|154.41500|000.0|154.41500|000.0|L|N|
11.42|154.40000|000.0|156.24000|OST|H|N|
11.43|169.97500|000.0|169.17500|000.0|H|N|MNF Admin Net
11.44|171.55000|000.0|164.50000|000.0|H|N|MNF Fire Net
11.45|172.40000|000.0|164.12500|000.0|H|N|MNF Service Net
11.46|155.75250|156.7|155.75250|156.7|L|N|
11.47|155.16000|000.0|155.16000|127.3|L|N|
11.48|151.13750|156.7|159.47250|OST|L|N|
11.49|151.28750|110.9|000.00000|000.0|L|N|
11.50|151.31000|110.9|000.00000|000.0|L|N|
11.51|155.16000|000.0|155.16000|127.3|L|N|
11.52|155.26500|000.0|155.26500|156.7|L|N|
11.53|156.80000|000.0|156.80000|000.0|L|W|
11.54|157.10000|000.0|157.10000|000.0|L|W|
11.55|157.12500|000.0|157.12500|000.0|L|W|
11.56|157.17500|000.0|157.17500|000.0|L|W|
11.57|162.52500|000.0|000.00000|000.0||W|
11.58|162.55000|000.0|000.00000|000.0||W|
11.59|159.07500|156.7|000.00000|000.0||N|RX Only-LE Channel
11.60|158.73000|156.7|000.00000|000.0||N|RX Only-LE Channel
11.61|155.98500|192.8|000.00000|000.0||N|RX Only-LE Channel
11.62|154.75500|210.7|000.00000|000.0||N|RX Only-LE Channel
11.63|154.86000|210.7|000.00000|000.0||N|RX Only-LE Channel
11.64|155.61000|167.9|000.00000|000.0||N|RX Only-LE Channel
11.65|154.84500|D026|000.00000|000.0||N|RX Only-LE Channel
11.66|154.80000|210.7|000.00000|000.0||N|RX Only-LE Channel
11.67|155.91000|210.7|000.00000|000.0||N|RX Only-LE Channel
11.68|151.62500|000.0|000.00000|000.0||N|RX Only-LE Channel
11.69|151.47500|179.9|000.00000|000.0||N|RX Only-LE Channel
11.70|173.3625|NAC 707|173.3625|NAC 707|||P25 LICENSE WROI563
11.71|153.75500|000.0|154.98000|000.0|H|N|Travel Net
11.72|168.62500|000.0|168.62500|110.9|L|N|Emergency
12.1|151.25000|110.9|159.40500|000.0|H|N|CDF HUU LOCAL NET
12.2|154.07000|000.0|159.00000|000.0|H|N|Humboldt Co. Fire Net
12.3|151.17500|192.8|151.17500|192.8|L|N|
12.4|151.34000|192.8|151.34000|192.8|L|N|
12.5|151.40000|192.8|151.40000|192.8|L|N|
12.6|159.36750|192.8|159.36750|192.8|L|N|CDF Air-to-Ground 3
12.7|151.35500|103.5|159.30000|000.0|H|N|
12.8|151.26500|103.5|159.33000|000.0|H|N|
12.9|153.95000|000.0|154.38500|000.0|H|N|CDF MEU Red
12.10|151.08500|000.0|156.19500|000.0|H|N|CDF MEU Blue
12.11|155.94000|146.2|150.77500|100.0|H|N|Shelter Cove/Humboldt Co. Fire Rpt
12.12|153.77000|173.8|153.77000|173.8|L|N|Rio Dell Fire Tac
12.13|154.23500|203.5|156.10500|186.2|H|N|Fortuna Fire - Repeater
12.14|153.83000|000.0|153.83000|203.5|L|N|Fortuna Fire - Tac 1
12.15|154.31000|000.0|154.31000|203.5|L|N|Fortuna Fire - Tac 2 Traffic Control
12.16|154.37000|141.3|158.82000|141.3|H|N|Humboldt Bay Fire Command 1
12.17|154.37000|NAC 293|158.82000|NAC 293|H|N|HB Fire C1, P25 ID 2222, C4FM & CQPSK
12.18|153.95000|100.0|159.04500|100.0|H|N|Humboldt Bay Fire Command 4
12.19|153.95000|NAC 293|159.04500|NAC 293|H|N|HB Fire C4, P25 ID 2222, C4FM & CQPSK
12.20|154.43000|NAC 293|154.43000|NAC 293|L|N|Humboldt Bay Fire Tac 2
12.21|154.32500|NAC 293|154.32500|NAC 293|L|N|Humboldt Bay Fire Tac 3
12.22|154.01000|146.2|154.01000|146.2|L|N|Loleta Fire
12.23|151.03250|146.2|151.03250|146.2|L|N|Loleta Fire Tac
12.24|154.17500|151.4|154.17500|151.4|L|N|Ferndale Fire
12.25|158.86500|151.4|158.86500|151.4|L|N|Ferndale Tac 1
12.26|153.89000|151.4|153.89000|151.4|L|N|Kneeland Fire TAC 1
12.27|154.13000|192.8|158.94000|192.8|H|N|North Bay Command
12.28|151.12250|192.8|151.12250|192.8|L|N|Arcata Fire - Tac 1
12.29|155.76750|192.8|155.76750|192.8|L|N|Arcata Fire - Tac 2
12.30|152.40500|151.4|157.66500|151.4|H|N|Arcata Ambulance Repeater
12.31|154.14500|162.2|150.79000|162.2|H|N|Petrolia Fire Repeater
12.32|154.44500|000.0|154.44500|000.0|L|N|Honeydew Fire
12.33|154.38500|000.0|154.38500|000.0|L|N|Orick Fire Tac
12.34|154.40000|000.0|154.40000|000.0|L|N|Trinidad Fire Tac
12.35|154.20500|146.2|154.20500|146.2|L|N|Fieldbrook Fire Tac
12.36|155.40000|173.8|150.77500|173.8|H|N|Blue Lake Fire Repeater
12.37|153.77000|173.8|153.77000|173.8|L|N|Blue Lake Fire Tac
12.38|154.31000|000.0|153.83000|100.0|H|N|Willow Creek Fire
12.39|154.41500|167.9|155.92500|167.9|H|N|Trinity County Fire Oregon MNT
12.40|154.78500|114.8|158.76000|167.9|H|N|Trinity Co Fire Net Pickett
12.41|154.25000|000.0|158.86500|000.0|H|N|Del Norte County Dispatch(T3/T10)
12.42|154.25000|114.8|158.86500|118.8|H|N|Del Norte Co Fire Disp-Klamath
12.43|151.10000|114.8|159.06000|146.2|L|N|Del Norte Crescent City CMD
12.44|154.44500|000.0|154.44500|000.0|L|N|Del Norte Crescent City Tac1
12.45|154.33500|000.0|154.33500|000.0|L|N|Del Norte Crescent City Tac2
12.46|154.41500|192.8|154.01000|192.8|H|N|Del Norte Repeated TAC - Gasquet
12.47|154.41500|000.0|154.41500|000.0|L|N|Gasquet TAC 2
12.48|153.77000|000.0|154.35500|110.9|H|N|Klamath Tactical
12.49|153.77000|110.9|153.77000|110.9|L|N|Klamath TAC 2
12.50|154.34000|167.9|159.16500|167.9|H|N|Smith River FPD CMD
12.51|154.34000|000.0|154.34000|000.0|L|N|Smith River FPD TAC
12.52|156.2025|110.9|153.93500|110.9|H|N|Fort Dick FPD CMD
12.53|156.20250|110.9|156.20250|110.9|L|N|Fort Dick FPD TAC
12.54|170.47500|000.0|165.75000|000.0|H|N|Six Rivers Forest - Admin
12.55|155.38500|156.7|150.80500|156.7|H|N|HIA Fire Net
12.56|154.19000|162.2|154.19000|162.2|L|N|HIA Tac 1
12.57|154.35500|192.8|154.35500|192.8|L|N|HIA Tac 2
12.58|155.10000|146.2|155.10000|146.2|L|N|HIA Tac 3
12.59|155.02500|000.0|153.93500|94.8|H|N|Hoopa Ambulance
12.60|172.77500|000.0|171.72500|100.0|H|N|BIA Admin
12.61|155.77500|127.3|151.47500|127.3|H|N|Orleans VFD Repeater
12.62|151.01000|179.9|151.01000|179.9|L|N|Dept. Parks & Recreation Direct
12.63|171.38750|000.0|169.57500|146.2|H|N|Siskiyou USFS - EAST
12.64|171.15000|000.0|168.75000|103.5|H|N|Siskiyou USFS - WEST
12.65|157.10000|000.0|157.10000|000.0|L|W|USCG Channel 22
12.66|156.07500|156.7|156.07500|156.7|H|N|
12.67|159.26250|192.8|159.26250|192.8|L|N|CDF Air-to-Ground 2
12.68|151.22000|192.8|151.22000|192.8|L|N|CDF Air-to-Ground 1
12.69|151.31000|110.9|000.00000|000.0||N|CDF licensed freq RX only
12.70|172.37500|000.0|164.17500|000.0|H|N|USFS Six Rivers NF
12.71|168.20000|000.0|168.20000|000.0|L|N|
12.72|167.60000|000.0|167.60000|000.0|L|N|SRF Primary Air to Ground
12.73|166.87500|000.0|166.87500|000.0|L|N|SRF Secondary Air to Ground
12.74|167.88750|000.0|000.00000|000.0||N|FED Receive only
12.75|169.98750|000.0|164.42500|000.0|H|N|
12.76|168.35000|000.0|168.35000|000.0|H|N|
12.77|154.74000|192.8|000.00000|000.0||N|
12.78|155.07000|000.0|000.00000|000.0||N|Humboldt Co. Sheriff - T3
12.79|155.85000|000.0|000.00000|000.0||N|Humboldt Co Sheriff Tactical 4
12.80|153.98000|110.9|000.00000|000.0||N|Del Norte SO/Crescent City PD
12.81|154.86000|000.0|000.00000|000.0||N|Trinity Co. Sheriff
12.82|154.75500|000.0|000.00000|000.0||N|Mendocino Co. Sherrif
12.83|150.77500|000.0|000.00000|000.0||N|Bureau of Indians Affairs LE
12.84|155.25000|118.8|000.00000|000.0||N|Fortuna PD
12.85|154.95000|NAC 293|000.00000|000.0||N|Eureka PD
12.86|155.43000|146.2|000.00000|000.0||N|Arcata PD
12.87|155.00250|118.8|000.00000|000.0||N|Ferndale PD
12.88|154.96500|146.2|000.00000|000.0||N|Rio Del PD
12.89|159.09000|141.3|000.00000|000.0||N|Humboldt State University PD
12.90|155.02500|94.8|000.00000|000.0||N|Hoopa PD
12.91|154.68000|94.8|000.00000|000.0||N|Hum Co Drug Task Force
12.92|154.05500|000.0|000.00000|000.0||N|Yurok Public Safety
12.93|153.75500|000.0|154.98000|000.0|H|N|Travel Net
12.94|168.62500|000.0|168.62500|110.9|L|N|Emergency`;
